import { sesh } from '@/storage'

const HSQ_USER_LOCATION = 'HSQ_USER_LOCATION'

export const getUserLocation = () => sesh.getItem(HSQ_USER_LOCATION)
export const setUserLocation = address => sesh.setItem(HSQ_USER_LOCATION, address)
